import authStore from '@/features/auth/stores/auth/auth.store'

function authRequestInterceptor(input: RequestInfo, init?: RequestInit, isFormData?: boolean) {
  if (!window) {
    return Promise.reject()
  }
  const authToken = authStore.authToken
  const headers = new Headers(init?.headers)

  if (authToken) {
    headers.set('Authorization', `Bearer ${authToken}`)
  }

  if (!headers.has('Content-type') && !isFormData) {
    headers.set('Content-type', 'application/json')
  }
  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json')
  }

  return fetch(input, { ...init, headers })
}

function toErrorMessage(raw: unknown): string {
  if (typeof raw === 'string' && raw.length > 0) return raw
  if (raw && typeof raw === 'object') {
    const msg = (raw as { message?: unknown }).message
    if (typeof msg === 'string' && msg.length > 0) return msg
    try {
      return JSON.stringify(raw)
    } catch {
      /* fall through */
    }
  }
  return 'Unknown error'
}

async function fetchClient(input: RequestInfo, init?: RequestInit, isFormData?: boolean): Promise<any> {
  if (!window) {
    return Promise.reject()
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-expect-error
  const response = await authRequestInterceptor(`${import.meta.env.VITE_API_URL}${input}`, init, isFormData)
  const json = await response.json()

  if (!response.ok) {
    const errorMessage = toErrorMessage(json?.error ?? json?.message)
    const error: any = new Error(errorMessage)
    error.status = response.status
    error.response = json
    throw error
  }

  return json
}

export async function fetchSSE(
  input: string,
  init: RequestInit,
  onEvent: (event: string, data: any) => void,
): Promise<void> {
  if (!window) {
    return Promise.reject()
  }

  const headers = new Headers(init?.headers)
  const authToken = authStore.authToken
  if (authToken) {
    headers.set('Authorization', `Bearer ${authToken}`)
  }
  if (!headers.has('Content-type')) {
    headers.set('Content-type', 'application/json')
  }
  headers.set('Accept', 'text/event-stream')

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-expect-error
  const response = await fetch(`${import.meta.env.VITE_API_URL}${input}`, {
    ...init,
    headers,
  })

  if (!response.ok) {
    const error: any = new Error('SSE request failed')
    error.status = response.status
    throw error
  }

  const reader = response.body!.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })

    // SSE events are separated by double newlines
    const parts = buffer.split('\n\n')
    buffer = parts.pop() || '' // Keep incomplete event in buffer

    for (const part of parts) {
      if (!part.trim()) continue

      let eventName = ''
      let eventData = ''

      for (const line of part.split('\n')) {
        if (line.startsWith('event: ')) {
          eventName = line.slice(7)
        } else if (line.startsWith('data: ')) {
          eventData = line.slice(6)
        }
      }

      if (eventName && eventData) {
        console.log(`[fetchSSE] Received event: ${eventName}`, eventData.slice(0, 100))
        try {
          onEvent(eventName, JSON.parse(eventData))
        } catch {
          onEvent(eventName, eventData)
        }
      }
    }
  }
}

export default fetchClient
